import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config/config';

import chartimg from '../../src/Components/Images/d-01.jpg';

const AdminDashboard = () => {
    const [notificationText, setNotificationText] = useState('');

    // Fetch notification on page load
    useEffect(() => {
        fetchNotification();
    }, []);

    const fetchNotification = async () => {
        try {
            const res = await axios.get(`${config.API_BASE_URL}/api/admin/get_notification`); // Update with your correct API route
            setNotificationText(res.data?.text || '');
        } catch (error) {
            console.error('Error fetching notification:', error);
        }
    };

    const handleInputChange = (e) => {
        setNotificationText(e.target.value);
    };

    const handleUpdateNotification = async () => {
        try {
            await axios.put(`${config.API_BASE_URL}/api/admin/update_notification`, { text: notificationText }); // Update with your correct API route
            alert('Notification updated successfully!');
        } catch (error) {
            console.error('Error updating notification:', error);
            alert('Failed to update notification.');
        }
    };


    const [college, setCollege] = useState([]);

    useEffect(() => {
        const fetchCollegeData = async () => {
            try {
                const response = await axios.get(
                    `${config.API_BASE_URL}/api/admin/get_collegespage`
                );
                const fetchedData = response.data.collegePages || [];
                setCollege(fetchedData);
                console.log("fetchedData", fetchedData); // Log for debugging
            } catch (error) {
                console.error("Error fetching college data:", error);
            }
        };

        fetchCollegeData();
    }, []);

    const [lead, setLead] = useState([]);

    useEffect(() => {
        const fetchleadData = async () => {
            try {
                const response = await axios.get(
                    `${config.API_BASE_URL}/api/user/getall_leads`
                );
                const fetchedData = response.data.leadData || [];
                setLead(fetchedData);
                console.log("fetchedData", fetchedData); // Log for debugging
            } catch (error) {
                console.error("Error fetching college data:", error);
            }
        };

        fetchleadData();
    }, []);


    const [review, setReview] = useState([]);

    useEffect(() => {
        const fetchreviewData = async () => {
            try {
                const response = await axios.get(
                    `${config.API_BASE_URL}/api/user/getall_review`
                );
                const fetchedData = response.data.ReviewData || [];
                setReview(fetchedData);
                console.log("fetchedData", fetchedData); // Log for debugging
            } catch (error) {
                console.error("Error fetching college data:", error);
            }
        };

        fetchreviewData();
    }, []);

    const [stream, setStream] = useState([]);

    useEffect(() => {
    const fetchStreamData = async () => {
        try {
            const response = await axios.get(
            `${config.API_BASE_URL}/api/admin/getall_streams`
            );
            const fetchedData = response.data || [];
            setStream(fetchedData);
            console.log("fetchedData", fetchedData); // Log for debugging
        } catch (error) {
            console.error("Error fetching college data:", error);
        }
        };

        fetchStreamData();
    }, []);

    return (
        <div className="container mt-1 pt-1">
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-10">
                    <div className="">
                        <h1 className='dashboard_heading'>Dashboard User</h1>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-3">
                            <div className="card admin_details_card">
                                <div className="card-body ">
                                    <h5>
                                        Colleges
                                    </h5>
                                    <h1 className='mt-4 fw-bold'>{college.length}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="card admin_details_card">
                                <div className="card-body">
                                    <h5>
                                        Leads
                                    </h5>
                                    <h1 className='mt-4 fw-bold'>{lead.length}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="card admin_details_card">
                                <div className="card-body">
                                    <h5>
                                        Stream
                                    </h5>
                                    <h1 className='mt-4 fw-bold'>{stream.length}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="card admin_details_card">
                                <div className="card-body">
                                    <h5>
                                        Review
                                    </h5>
                                    <h1 className='mt-4 fw-bold'>{review.length}</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container mt-5 pt-2">
                        <div className="row">
                            <div className="col">
                                <img src={chartimg} className='w-100' alt="" />
                            </div>
                        </div>
                    </div>

                    <div className="row pt-5 m-2">
                        <h2>Notification</h2>
                        <input
                            type="text"
                            placeholder="Notification"
                            className="form-control"
                            value={notificationText}
                            onChange={handleInputChange}
                        />
                        <button className="mybtn mt-3 w-50" onClick={handleUpdateNotification}>
                            Update Notification
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;
